import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'common-progress-bar',
	standalone: true,
	templateUrl: './common-progress-bar.widget.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./common-progress-bar.widget.scss'],
})
export class CommonProgressBarWidget {

	public percentage = input.required<number>();

}